import { color } from 'd3-color';
import styled, { css } from "styled-components";

const commonStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100rem;
  max-width: 90vw;
  .textoRetiradaLocal{
    text-align: left;
    padding: 1rem 0 3rem;
    width: 90%;
    color: ${(props) => props.theme.colors.tertiary};
    position: relative;

    &::after{
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 30%;
      height: 2px;
      border-radius: 100%;
      background-color: ${(props) => props.theme.colors.elements};
    }
  }

  .flex{
    display: flex;
    flex-direction: column;
    width: 90%;
    align-items: flex-start;
    padding: 4rem 0 0;

    label{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      color: ${(props) => props.theme.colors.tertiary};
      gap: 1rem;
    }

    .flex-inputs{
      display: flex;
      gap: 1rem;
      padding-top: 1rem;
    }
  }

  .tituloIntervalos{
    font-weight: 700;
    text-align: left;
    color: ${(props) => props.theme.colors.tertiary};
    padding: 3rem 0 0;
    width: 90%;
  }

  .dropdown{
    display: flex;
    flex-direction: column;
    gap: 5rem;
    width: 90%;
    padding: 4rem 0 0;
    .intervalos{
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2rem;
      
      .diasContainer{
        display: flex;
        flex-direction: column;
        gap: 2rem;
        .flexDias{
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 2rem;

          .dia{
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            color: ${(props) => props.theme.colors.white};
            background-color: ${(props) => props.theme.colors.elements};
            cursor: pointer;
          }

          >.ativo{
            color: ${(props) => props.theme.colors.primary};
            border: 1px solid ${(props) => props.theme.colors.primary};
          }

          >.disabled{
            opacity: 0.5;
            color: ${(props) => props.theme.colors.elements};
            background-color: ${(props) => props.theme.colors.disabledDaysWeek};
            border: none;
            &:hover{
              cursor: not-allowed;
            }
          }
        }
      }

      .horariosContainer{
        width: 100%;
        .horariosFlex{
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          padding: 2rem 0;
          width: 100%;

          .horarios{
            display: flex;
            gap: 2rem;
            align-items: center;
            width: 100%;

            .x{
              margin-top: 4rem;
              right: -3rem;
              position: absolute;
              cursor: pointer;
              color: ${(props) => props.theme.colors.tertiary};
            }
          }
        }
      }
    }

    .adicionar{
      cursor: pointer;
      color: ${(props) => props.theme.colors.primary};
    }
  }
`;

export const ContainerRetiradaNoLocalContainer = styled.div<{
  configIn: "empresa" | "configuracoes";
}>`
  ${commonStyles}
  ${({ configIn }) =>
    configIn === "configuracoes" &&
    css`
      width: 100%;
      max-width: none;
      .textoRetiradaLocal{
        width: 100%;
      }
      .flex{
        width: 100%;
      }

      .tituloIntervalos{
        width: 100%;
      }
      .dropdown {
        width: 100%;
        .adicionar {
          text-align: center;
        }
        .intervalos {
          margin: 0;
          padding: 0;
          row-gap: 2rem;
          width: 100%;
          flex-direction: row;
          @media (max-width: 604px) {
            flex-wrap: wrap;
          }
          .diasContainer {
            align-items: flex-start;
            justify-content: start;
            > label {
              display: block;
              color: ${(props) => props.theme.colors.tertiary};
            }
          }
          .adicionar {
            align-self: center;
            padding-top: 4rem;
            justify-self: center;
            white-space: nowrap;
          }
          .horariosContainer {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-end;
            align-items: flex-end;
            column-gap: 4rem;
            row-gap: 1rem;
            .horariosFlex {
              width: calc(50% - 4rem);
              min-width: 100%;
              padding: 0;
              .horarios {
                gap: 1rem;
                .x {
                  position: static;
                }
              }
            }
            .adicionar {
              width: calc(50% - 4rem);
              min-width: 40rem;
              text-align: center;
            }
            @media (max-width: 580px) {
              justify-content: flex-start;
            }
          }
          &::after {
            display: none;
          }
        }
      }
    `}
`;
